import { RootState } from '../../store';

export const verifySelector = (state: RootState) => state.verifyState;
export const verifyStatusSelector = (state: RootState) => state.verifyStatusState;
